module.exports = __webpack_public_path__ + "img/instagram.5df86af9.svg";